var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Editor,{staticClass:"w-full form-input form-input-bordered py-2 form-input-textarea",attrs:{"placeholder":_vm.$t('Enter text'),"value":_setup.currentText,"escape-on-init":!_setup.isRteResponse,"editable":!_setup.isReadOnly},on:{"input":_setup.debounceUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }